import Prescription from "@/views/prescriptions/prescription.vue";
import Prescriptions from "@/views/prescriptions/index.vue";

export default [
  {
    path: "receituario",
    name: "Receituário",
    component: Prescriptions,
  },
  {
    path: "receituario/:prescription_id",
    name: "Editar Receituário",
    component: Prescription,
  },
  {
    path: "receituario/novo",
    name: "Novo Receituário",
    component: Prescription,
  },
];
